import { FC, useMemo, useState } from 'react';

import { CollectionName } from '@/shared/lib/sj-orm/constants';

import { ModalContainerV1 } from '../containers/ModalContainerV1';
import { ModalContainerV2 } from '../containers/ModalContainerV2';

import { InterwillDocumentFormType } from './PersonaldForm/types';
import { InterwillAssetForm } from './AssetForm';
import { InterwillPersonalIdForm } from './PersonaldForm';
import { InterwillCreateEntityModalProps } from './types';
import { useTitle } from './useTitle';

export const InterwillCreateEntityModal: FC<InterwillCreateEntityModalProps> = ({
  entityType,
  onSubmit,
}) => {
  const [documentFormType, setDocumentFormType] = useState<InterwillDocumentFormType | null>(null);

  const form = useMemo(() => {
    if (entityType === CollectionName.ASSETS) {
      return <InterwillAssetForm onSubmit={onSubmit} />;
    }

    if (entityType === CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS) {
      return (
        <InterwillPersonalIdForm onSubmit={onSubmit} setDocumentFormType={setDocumentFormType} />
      );
    }

    return null;
  }, [entityType]);

  if (!entityType || !form) {
    return null;
  }

  const title = useTitle({ entityType, documentFormType });
  const isModalUI = entityType === CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS;

  const Container = isModalUI ? ModalContainerV2 : ModalContainerV1;

  return (
    <Container title={title} pinBottom={true}>
      {form}
    </Container>
  );
};
